import React, { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import visionLogo from "../../../assets/img/logo-vision.png"
import amerinodeLogo from "../../../assets/img/logo-amerinode.jpeg"
import { Context } from "../../../context/UserContext";

function Login() {

  const [ user, setUser ] = useState({})
  const { login } = useContext(Context)

  const handleOnChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value })
    // console.log(user)
  }

  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault()
    login(user)
    // navigate('/app');
    // console.log(user)
  }

  return (
    // LAYOUT
    // <div className="flex flex-col justify-between min-h-screen bg-red-200">
    //   <div className=" bg-yellow-200 h-full flex flex-1 justify-center items-center">
    //     <div className="flex justify-center items-center">TESTE</div>
    //   </div>
    //   <div className=" bg-green-200">FOOTER</div>
    // </div>


    <div className="flex flex-col justify-between min-h-screen bg-neutral-100">
      <div className="h-full flex flex-col flex-1 justify-center items-center px-6 py-12 lg:px-8">
        {/* <div className="sm:mx-auto sm:w-full sm:max-w-sm"> */}
          <img
            className="mx-auto h-48 w-auto"
            src={visionLogo}
            alt="Logo"
          />
          {/* <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Sign in to your account
          </h2> */}
        {/* </div> */}

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form id="login_form" className="space-y-6" onSubmit={handleLogin}>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Email
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="block w-full rounded-2xl border-0 px-4 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  onChange={handleOnChange}
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Senha
                </label>
                <div className="text-sm">
                  <a
                    href="/login"
                    className="font-semibold text-indigo-600 hover:text-indigo-500"
                  >
                    Esqueceu a senha?
                  </a>
                </div>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="block w-full rounded-2xl border-0 px-4 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  onChange={handleOnChange}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-2xl bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Login
              </button>
            </div>
          </form>

          <p className="mt-10 text-center text-sm text-gray-500">
            Ainda não é registrado?
            <a href="/register" className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500 ms-2">Solicitar Registro</a>
          </p>
        </div>
      </div>
      <div className="flex flex-col items-center w-full gap-2 py-4">
        <div><img
            className="mx-auto h-4 w-auto"
            src={amerinodeLogo}
            alt="Your Company"
          /></div>
        <div className=" text-xs">Brasil • EUA • Argentina • Peru • Equador • Colômbia • México • Chile</div>
      </div>
    </div>
  );
}

export default Login;
